import { render, staticRenderFns } from "./node-date.vue?vue&type=template&id=2c858fff&"
import script from "./node-date.vue?vue&type=script&lang=js&"
export * from "./node-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports